import { currency, WHOLE_NUMBER_OPTIONS } from '@shared/utils';

export const formattedDiscount = (coupon: { amount: number; percent: number }) => {
  const isPercent = coupon.percent > 0 && coupon.amount === 0;
  return isPercent
    ? coupon.percent.toLocaleString('en', { style: 'percent' })
    : currency(coupon.amount, WHOLE_NUMBER_OPTIONS);
};
